export async function requestCancelLikeResource(
  id: number,
  type: ResourceType
) {
  return http.post('/v1/like/cancel', {
    id,
    type
  })
}
